export const GET_PAGEMAPPINGS = "GET_PAGEMAPPINGS"
export const SET_PAGEMAPPINGS = "SET_PAGEMAPPINGS"
export const GET_PAGEMAPPING = "GET_PAGEMAPPING"
export const SET_PAGEMAPPING = "SET_PAGEMAPPING"
export const GET_PAGEMAPPING_BY_ID = "GET_PAGEMAPPING_BY_ID"
export const UPDATE_PAGEMAPPING = "UPDATE_PAGEMAPPING"
export const CREATE_PAGEMAPPING = "CREATE_PAGEMAPPING"
export const SET_PAGEMAPPING_LOADER = "SET_PAGEMAPPING_LOADER"
export const DELETE_PAGEMAPPING_SCHEMA = "DELETE_PAGEMAPPING_SCHEMA"
export const DELETE_PAGEMAPPING = "DELETE_PAGEMAPPING"